<template>
  <!-- Main Panel -->
  <div ref="main-panel">

    <!--CONTENT-->
    <div class="bg-white w-full h-auto" style="position: relative;">
      <SidePanelToggle v-if="isBigScreen"
                       :sidePanelActive="sidePanelActive"
                       @toggleSidePanel="toggleSidePanel">
      </SidePanelToggle>

      <transition name="panel-fade" mode="out-in">
        <component :is="mainPanelMode"
                   :currentVdoSetTopic="currentVdoSetTopic"
                   :keepCounting="keepCounting"
                   :countLearningPercent="countLearningPercent"
                   :classSection="classSection"

                   :currentCourseOutlineUnit="currentCourseOutlineUnit"
                   :examMode="examMode"
                   :currentStudentUnitTest="currentStudentUnitTest"
                   @setNewStudentUnitTestToCourseOutlineUnits="setNewStudentUnitTestToCourseOutlineUnits"
                   @startLearning="startLearning"
                   @setDoingExam="setDoingExam"
                   @setTriggerLoading="setTriggerLoading"
        />
      </transition>

    </div>

  </div>
</template>

<script>
import SidePanelToggle from "./sidepanel-toggle";
import cover from "./panel-cover";

export default {
  props:[
    'currentVdoSetTopic',
    'sidePanelActive',
    'toggleSidePanel',
    'mainPanelMode',
    'keepCounting',
    'countLearningPercent',
    'classSection',

    'currentCourseOutlineUnit',
    'examMode',
    'currentStudentUnitTest',
    'setNewStudentUnitTestToCourseOutlineUnits',
    'startLearning',
    'setDoingExam',
    'setTriggerLoading',
    'isBigScreen',
  ],
  components: {
    SidePanelToggle,
    cover,
    vdo: () => import( "./MainPanel-Vdo"),
    // test: () => import("./MainPanel-StudentUnitTest")
  },
}

</script>

<style>

</style>
